import _objectSpread from "/home/travis/build/Arquisoft/viade_es4b/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/home/travis/build/Arquisoft/viade_es4b/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useDebugValue } from 'react';
import useWebId from './useWebId';
import useLiveUpdate from './useLiveUpdate';
import ExpressionEvaluator from '../ExpressionEvaluator';
var value = {
  result: undefined,
  pending: true,
  error: undefined
};
var list = {
  result: [],
  pending: true,
  error: undefined
};
var none = {};
/**
 * Evaluates the Solid LDflex expression.
 * Returns an array of [result, pending, error].
 */

export default function useLDflex(expression) {
  var listMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // The user's WebID and recent updates might influence the evaluation
  var webId = useWebId();
  var latestUpdate = useLiveUpdate(); // Obtain the latest expression result from the state

  var _useState = useState(listMode ? list : value),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      result = _useState2$.result,
      pending = _useState2$.pending,
      error = _useState2$.error,
      update = _useState2[1];

  useDebugValue(error || result, toString); // Set up the expression evaluator

  useEffect(function () {
    var evaluator = new ExpressionEvaluator();
    var query = {
      result: expression
    };
    evaluator.evaluate(!listMode ? query : none, listMode ? query : none, function (changed) {
      return update(function (current) {
        return _objectSpread({}, current, changed);
      });
    });
    return function () {
      return evaluator.destroy();
    };
  }, [expression, latestUpdate, webId && typeof expression === 'string']); // Return the state components

  return [result, pending, error];
}
export function toString(object) {
  return Array.isArray(object) ? object.map(toString) : "".concat(object);
}